export default __webpack_public_path__ + "static/media/feedback-service.64a2a076.svg";